// TODO replace with customers duck and "current" filter

import { apiFetch, apiAction } from 'utils';
import {Schema} from 'normalizr';

const actionType = (action) => `schooladmin/customer/${action}`;

const config = {
  apiPath: 'customer',
  schema: new Schema('customer')
};

const types = {
  LOAD_BEGIN: actionType('LOAD_BEGIN'),
  LOAD_ERROR: actionType('LOAD_ERROR'),
  LOAD_SUCCESS: actionType('LOAD_SUCCESS'),
  SAVE_BEGIN: actionType('SAVE_BEGIN'),
  SAVE_SUCCESS: actionType('SAVE_SUCCESS'),
  SAVE_ERROR: actionType('SAVE_ERROR')
};

const initialState = {
  object: {},
  ready: false,
  pending: true,
  error: false
};

const reducer = (state = initialState, action) => {
  const {payload = {}} = action;

  switch (action.type) {
    case types.LOAD_BEGIN:
    case types.SAVE_BEGIN:
      return {...state, ready: false, pending: true, error: false};

    case types.LOAD_SUCCESS:
    case types.SAVE_SUCCESS:
      return {
        ...state,
        object: payload['customer'],
        ready: true,
        pending: false
      };

    case types.LOAD_ERROR:
      return {...state, error: true};

    default:
      return state;
  }
};

const load = () => apiAction(
    types.LOAD_BEGIN, types.LOAD_SUCCESS, types.LOAD_ERROR,
    (state) => apiFetch.get(state, config.apiPath),
    {entityName: 'customer'}
);

const save = object => apiAction(
  types.SAVE_BEGIN, types.SAVE_SUCCESS, types.SAVE_ERROR,
  (state) => apiFetch.put(state, config.apiPath, {['customer']: object}),
  {entityName: 'customer', create: false, update: true}
);

const deleteMmsPhoneNumber = () => apiAction(
  types.SAVE_BEGIN, types.SAVE_SUCCESS, types.SAVE_ERROR,
  (state) => apiFetch.post(state, `${config.apiPath}/delete_mms_phone_number`),
  {entityName: 'customer', create: false, update: true}
);

export default reducer;

export const actions = {
  load,
  save,
  deleteMmsPhoneNumber
};
